import api from './api'
import { User, ApiResponse } from '../types'

interface LoginResponse {
  token: string
  user: User
}

export const authService = {
  async login(identifier: string, password: string): Promise<LoginResponse> {
    const response = await api.post<ApiResponse<LoginResponse>>('/auth/login', {
      identifier,
      password,
    })
    return response.data.data
  },

  async forceChangePassword(newPassword: string, recoveryEmail?: string): Promise<User> {
    const response = await api.post<ApiResponse<User>>('/auth/force-change-password', {
      newPassword,
      recoveryEmail,
    })
    return response.data.data
  },

  async setRecoveryEmail(email: string): Promise<User> {
    const response = await api.post<ApiResponse<User>>('/auth/set-recovery-email', { email })
    return response.data.data
  },

  async getProfile(): Promise<User> {
    const response = await api.get<ApiResponse<User>>('/auth/me')
    return response.data.data
  },

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await api.post('/auth/change-password', { currentPassword, newPassword })
  },

  async register(data: {
    email: string
    password: string
    name: string
    role?: 'ADMIN' | 'EMPLOYEE'
  }): Promise<User> {
    const response = await api.post<ApiResponse<User>>('/auth/register', data)
    return response.data.data
  },

  async requestPasswordReset(email: string): Promise<{ message: string }> {
    const response = await api.post<ApiResponse<{ message: string }>>('/password/request-reset', { email })
    return response.data.data
  },

  async validateResetToken(token: string): Promise<boolean> {
    const response = await api.get<ApiResponse<{ valid: boolean }>>(`/password/validate-token/${token}`)
    return response.data.data.valid
  },

  async resetPassword(token: string, password: string): Promise<void> {
    await api.post('/password/reset', { token, password })
  },

  async verifyEmail(code: string): Promise<User> {
    const response = await api.post<ApiResponse<User>>('/auth/verify-email', { code })
    return response.data.data
  },

  async resendVerificationCode(): Promise<{ success: boolean }> {
    const response = await api.post<ApiResponse<{ success: boolean }>>('/auth/resend-verification')
    return response.data.data
  },

  async updateRecoveryEmail(newEmail: string): Promise<User> {
    const response = await api.post<ApiResponse<User>>('/auth/update-recovery-email', { newEmail })
    return response.data.data
  },

  // Impersonate: Admin se loguea como un empleado
  async impersonate(employeeId: string): Promise<LoginResponse> {
    const response = await api.post<ApiResponse<LoginResponse>>(`/auth/impersonate/${employeeId}`)
    return response.data.data
  },
}
